import * as React from "react"
import { Link } from "gatsby"

import HeaderNav from "./HeaderNav"
import SEO from "./SEO"

type LayoutProps = {
  children: React.ReactNode
  title?: string
  location?: { pathname?: string }
  seo?: {
    title?: string
    description?: string
    image?: string
    imageAlt?: string
    imageWidth?: number
    imageHeight?: number
    type?: string
  }
}

const Layout = ({ children, title, location, seo }: LayoutProps) => {
  const isHomePage = location?.pathname === "/"

  return (
    <div className="site-shell">
      <SEO title={seo?.title || title} {...seo} />
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <header className="site-header">
        <div className="site-container site-header__inner">
          <Link className="site-brand" to="/" aria-label="Cary Stothart, home">
            <span className="site-brand__title">
              CARY STOTHART <span>/</span> PH.D.
            </span>
            <span className="site-brand__tagline">
              Cognitive Scientist &middot; Human Performance &middot;
              Decision-Making
            </span>
          </Link>
          <HeaderNav />
        </div>
      </header>
      <main
        id="main-content"
        className={
          isHomePage ? "site-main site-main--home" : "site-container site-main"
        }
      >
        {children}
      </main>
      <footer className="site-footer">
        <div className="site-container site-footer__inner">
          <span>© {new Date().getFullYear()} Cary Stothart</span>
          <span>Cognitive Scientist · Human Performance · Decision-Making</span>
        </div>
      </footer>
    </div>
  )
}

export default Layout
